import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/noone/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/noone/SupportProgramPage"

const support_program = () => (
  <Layout>
    <SEO title={PAGE.title.support_program} siteTitle="noone" />
    <HeadingL title={PAGE.title.support_program} target="noone" />
    <AssessmentPage />
  </Layout>
)

export default support_program;
